import { render } from "./PlaceField.vue?vue&type=template&id=575e1329"
import script from "./PlaceField.vue?vue&type=script&lang=js"
export * from "./PlaceField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/danielarabia/code/rea-nova/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PlaceField.vue"]])

export default __exports__